import { useConnect } from '@puzzlehq/sdk';
import { SelectedAccount } from './SelectedAccount';
import { Button, buttonVariants, Spinner } from 'ui_2';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useArcadeStoreState } from '@src/hooks/useArcadeStoreState';
import { useHasInjectedConnection } from '@puzzlehq/frontend-utils';
import { BiLinkExternal } from 'react-icons/bi';

export const ConnectButton = () => {
  const { connect, isConnected, loading } = useConnect({
    permissions: {
      programIds: {
        [import.meta.env.VITE_NETWORK!]: ['ALL_PROGRAM_IDS'],
      },
    },
    dAppInfo: {
      name: 'Puzzle Arcade Store',
    },
  });

  const { hasInjectedConnection, isLoading } = useHasInjectedConnection();

  if (isConnected) return;

  if (hasInjectedConnection === false && isLoading === false) {
    return (
      <a
        href='https://puzzle.online/wallet'
        target='_blank'
        className={buttonVariants({
          size: 'md',
          className: 'items-center gap-2',
        })}
      >
        Download Puzzle Wallet
        <BiLinkExternal />
      </a>
    );
  }

  return (
    <Button
      onClick={connect}
      size='md'
      variant='primary'
      disabled={loading}
      className='items-center gap-2'
    >
      Connect Wallet
      {loading && <Spinner />}
    </Button>
  );
};

export const ConnectOrAccount = ({
  showOnConnected = true,
}: {
  showOnConnected?: boolean;
}) => {
  const { isConnected, error } = useConnect({
    permissions: {
      programIds: {
        [import.meta.env.VITE_NETWORK!]: ['ALL_PROGRAM_IDS'],
      },
    },
    dAppInfo: {
      name: 'Puzzle Arcade Store',
    },
  });

  useEffect(() => {
    if (error) {
      const errorStr =
        typeof error === 'string' ? error : (error as Error).message;
      toast.error(errorStr);
    }
  }, [error]);

  const { account } = useArcadeStoreState();

  if (account && isConnected) {
    return showOnConnected ? <SelectedAccount account={account} /> : null;
  }

  return <ConnectButton />;
};
